import { Flex, Button, Spin } from "antd";
import { useQuery } from "@tanstack/react-query";
import { ColumnsType } from "antd/es/table";
import { useState } from "react";
import { queryKeys } from "../../services/react-query/queryKeys";
import { deleteProduct, listAllProducts } from "../../network/products";
import AddProductForm from "../../pages/product/addModal";
import DeleteModal from "../common/DeleteModal";
import HeadTable from "../GlobalTable/HeadTableD";
import EditProductForm from "../../pages/product/editModal";
import { BsPlusSquare } from "react-icons/bs";
import ProductsRowData from "../AntTable/tableRowsData/ProductsRowData";
import AntTable from "../AntTable/AntTable";
import Empty from "../common/Empty";
import { PlusOutlined } from "@ant-design/icons";
import { productType } from "../../types/product";
import { FormattedMessage, useIntl } from "react-intl";

const ProductTable = () => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [dataDelete, setDataDelete] = useState({ id: null, category_id: null });
  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState<productType>();
  const [activeModal, setActiveModal] = useState(null);
  const [search, setSearch] = useState("");
  const SearchInput = (e: any) => setSearch(e);
  const openModal = (modal: any) => {
    setActiveModal(modal);
  };

  const openEditModal = (modal: any, data: productType) => {
    setActiveModal(modal);
    setEditData(data);
  };

  const closeModal = () => {
    setEditModal(false);
    setDeleteModal(false);
    setActiveModal(null);
  };

  const showDeleteModal = (data: any) => {
    setDataDelete(data);
    setDeleteModal(true);
  };

  const handleDeleteCancel = () => {
    setDeleteModal(false);
  };

  const {
    data: listProducts,
    isLoading,
    isFetching,
    isError,
  } = useQuery([queryKeys.listProduct, search], () => listAllProducts(search));

  const count = listProducts?.data.length || 0; // get the length of the products
  const intl = useIntl();
  const columns: ColumnsType<any> = [
    {
      title: intl.formatMessage({ id: "product_name" }),
      dataIndex: "images",
      render: (text: any, record: any) => (
        <Flex
          justify="center"
          className="text-color-primary text-sm font-medium"
        >
          <span className="px-1 text-sm text-color-primary font-semibold capitalize">
            {record?.name}
          </span>
        </Flex>
      ),
    },
    {
      title: intl.formatMessage({ id: "brand_label" }),
      dataIndex: "brand_id",
      render: (text: any, record: any) => (
        <div className="text-[#9999A7]">
          <span className="text-sm font-medium">{record?.brand?.name}</span>
        </div>
      ),
    },
    {
      title: intl.formatMessage({ id: "available_quantity" }),
      dataIndex: "current_stock_quantity",

      render: (text: any, record: any) => (
        <div className="text-[#9999A7] text-sm font-medium">
          <span className="mx-1 font-semibold text-[#9999A7]">
            {record?.current_stock_quantity}
          </span>
        </div>
      ),
    },
    {
      title: intl.formatMessage({ id: "selling_price" }),
      dataIndex: "retail_price",

      render: (text: any, record: any) => (
        <Flex justify="center" className=" text-sm font-medium">
          <span className="text-color-primary font-semibold">
            {record?.retail_price?.amount || record?.retail_price}
          </span>
          <small className="text-[#9999A7] text-xs self-center mt-2 px-1">
            {intl.formatMessage({ id: "saudi_riyal" })}
          </small>
        </Flex>
      ),
    },
  ];

  const modalComponents = {
    AddProduct: <AddProductForm visible={true} onClose={closeModal} />,
    EditProduct: (
      <EditProductForm
        visible={true}
        onClose={closeModal}
        editProductData={editData}
      />
    ),
  };

  const renderModal = activeModal ? modalComponents[activeModal] : null;

  return (
    <div className="tabs p-6 bg-[#eef0ff] ">
      {renderModal}
      <DeleteModal
        visible={deleteModal}
        onClose={handleDeleteCancel}
        onDelete={deleteProduct}
        data={dataDelete?.category_id}
        optionalParam2={dataDelete?.id}
        confirmationHeader={intl.formatMessage({
          id: "delete_product_confirmation",
        })}
        confirmationText=""
        queryKey={queryKeys.listProduct}
        successMessage="Product deleted successfully"
      />

      <HeadTable
        data={listProducts?.data}
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        search={search}
        setSearch={SearchInput}
        placeHolderSerch={intl.formatMessage({ id: "search_placeholder" })}
        button={
          <Button
            type="primary"
            onClick={() => openModal("AddProduct")}
            icon={<BsPlusSquare />}
          >
            {intl.formatMessage({ id: "add_product_button" })}
          </Button>
        }
        optionalDiv={
          <>
            {/* <div>
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item key="delete">مسح</Menu.Item>
                  </Menu>
                }
              >
                <div className="border-[0.8px] border-solid border-[#9999A7] w-fit px-3 py-2 flex items-center rounded-lg cursor-pointer bg-white">
                  <ListSVG />
                </div>
              </Dropdown>
            </div> */}
            <div>
              <span className="text-sm text-[#00086D]">({count})</span>
              <span className="text-sm text-[#75757E] px-1">
                {intl.formatMessage({ id: "products" })}
              </span>
            </div>
          </>
        }
      />
      <Spin spinning={isLoading}>
        {listProducts?.data?.length > 0 ? (
          <AntTable
            tableColumns={columns}
            tableData={listProducts?.data || []}
            isLoading={isLoading}
            hideArrowExpand
            rowData={(record: any) => (
              <ProductsRowData
                data={record}
                deleteRowData={() => showDeleteModal(record)}
                editRowData={() => openEditModal("EditProduct", record)}
              />
            )}
          />
        ) : !isLoading ? (
          <Empty
            title={intl.formatMessage({ id: "no_products" })}
            subTitle={intl.formatMessage({ id: "add_product_now" })}
            buttons={
              <div>
                <Button
                  onClick={() => openModal("AddProduct")}
                  className="border-none bg-[#EEF0FF] shadow-none outline-none text-[#75757E]"
                  icon={<PlusOutlined />}
                >
                  <FormattedMessage id="add_product" />
                </Button>
              </div>
            }
          />
        ) : (
          <div className="min-h-[300px]"></div>
        )}
      </Spin>
    </div>
  );
};

export default ProductTable;
